import { clsx } from 'clsx';
import { FunctionComponent, ReactNode, TextareaHTMLAttributes } from 'react';
import { useController } from 'react-hook-form';
import { ErrorMessage } from 'softcat:components/error-message.tsx';
import { Form } from 'softcat:components/form.tsx';

type FormTextareaProperties = TextareaHTMLAttributes<HTMLTextAreaElement> & {
    label: ReactNode;
    name: string;
};

export const FormTextarea: FunctionComponent<FormTextareaProperties> = ({ label, name, ...textareaAttributes }) => {
    const { field, fieldState } = useController({ name });

    return (
        <div className="sm:grid sm:grid-cols-4 sm:items-start sm:gap-4">
            <Form.Label htmlFor={name}>{label}</Form.Label>

            <div className={'mt-2 sm:col-span-3 sm:mt-0'}>
                <textarea
                    id={name}
                    {...field}
                    {...textareaAttributes}
                    autoComplete={'off'}
                    className={clsx(
                        'block w-full rounded-md border-0 py-1.5 font-mono shadow-sm ring-1 read-only:border-0 focus:ring-2 focus:ring-inset disabled:bg-gray-50 disabled:text-gray-400 sm:text-sm sm:leading-6',
                        {
                            'text-gray-900 ring-gray-200 placeholder:text-gray-400 focus:ring-indigo-600': !fieldState.error,
                            'text-red-600 ring-red-600 placeholder:text-red-400 focus:ring-red-600': fieldState.error,
                        },
                    )}
                />

                {fieldState.error && (
                    <div className="mt-3">
                        <ErrorMessage>{fieldState.error.message}</ErrorMessage>
                    </div>
                )}
            </div>
        </div>
    );
};
